import Dropzone from "react-dropzone"
import styled from "styled-components"

const StyledDropzone = styled(Dropzone)`
  .trophy-picker-dropzone {
    border: none;
    height: 120px;
    width: 120px;
  }
`

export default StyledDropzone
